// // frontend/src/components/Admin/adminpage.js

// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import Sidebar from "./sidebar";
// import Navbar from "./navigation";
// import AdminFooter from "./adminfooter";
// import AdminCards from "./admincards";
// import UsersDetails from "./userdetails";
// import AdminDetails from "./admindetails";
// import DeviceDetails from "./devicedetails";
// // import AlertsPage from "./alertpage";
// import AdminAlertsPage from './AdminAlertsPage'; 
// import PatientDetails from "./patientdetails"; // ✅ Import PatientDetails component
// // import webSocketService from "./websocket";
// // import { addNotification } from "../../redux/slices/NotificationSlice";
// import './AdminCSS/admin.css';
// import BluetoothWiFiConnect from "./BluetoothWiFiConnect";


// const AdminPage = () => {
//   const [currentPage, setCurrentPage] = useState("dashboard");
//   const dispatch = useDispatch();

//   // useEffect(() => {
//   //   webSocketService.connect("ws://sens-able.manipal.net:8000/ws/notifications");

//   //   webSocketService.onMessage((notification) => {
//   //     console.log('handler received data:', notification);
//   //     dispatch(addNotification(notification));
//   //   });

//   //   return () => {
//   //     webSocketService.disconnect();
//   //   };
//   // }, [dispatch]);

//   const renderBodyContent = () => {
//     switch (currentPage) {
//       case "dashboard":
//         return <AdminCards onNavigate={setCurrentPage} />;
//       case "users":
//         return <UsersDetails />;
//       case "admins":
//         return <AdminDetails />;
//       case "devices":
//         return <DeviceDetails />;
//       case "patients":
//         return <PatientDetails />;
//       case "bluetooth-wifi-connect":
//         return <BluetoothWiFiConnect />;  // ✅ Render patient details
//       case 'admin-alerts':
//         return <AdminAlertsPage />;
//       // case "fall-alerts":
//       //   return <AlertsPage />;
//       default:
//         return <AdminCards onNavigate={setCurrentPage}  />;
//     }
//   };

//   return (
//     <div className="main-content">
//       <Sidebar onOptionClick={setCurrentPage} />
//       <Navbar />
//       <header className="admin-header">
//         <h1>
//           {currentPage === "dashboard"
//             ? "Admin Dashboard"
//             : currentPage === "users"
//             ? "Users"
//             : currentPage === "admins"
//             ? "Admins"
//             : currentPage === "devices"
//             ? "Devices"
//             : currentPage === "patients"
//             ? "Patients"
//             : currentPage === "bluetooth-wifi-connect"
//             ? "Patients"
//             // : currentPage === "fall-alerts"
//             // ? " Fall Alerts"
//             : currentPage === "admin-alerts"
//             ? "Alerts"
//             : "Page Not Found"}
//         </h1>
//       </header>
//       {renderBodyContent()}
//       <AdminFooter />
//     </div>
//   );
// };

// export default AdminPage;



// frontend/src/components/Admin/AdminPage.js

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Sidebar from "./sidebar";
import Navbar from "./navigation";
import AdminFooter from "./adminfooter";
import AdminCards from "./admincards";
import UsersDetails from "./userdetails";
import AdminDetails from "./admindetails";
import DeviceDetails from "./devicedetails";
import WatchAlerts from "./WatchAlerts";
import FallAlerts from "./FallAlerts";
import PatientDetails from "./patientdetails";
import BluetoothWiFiConnect from "./BluetoothWiFiConnect";
import "./AdminCSS/admin.css";

const AdminPage = () => {
  const [currentPage, setCurrentPage] = useState("dashboard");
  const dispatch = useDispatch();

  const renderBodyContent = () => {
    switch (currentPage) {
      case "dashboard":
        return <AdminCards onNavigate={setCurrentPage} />;

      case "users":
        return <UsersDetails />;

      case "admins":
        return <AdminDetails />;

      case "devices":
        return <DeviceDetails />;

      case "patients":
        return <PatientDetails />;

      case "bluetooth-wifi-connect":
        return <BluetoothWiFiConnect />;

      case "watch-alerts":
        return <WatchAlerts />;

      case "fall-alerts":   // ✅ Added
        return <FallAlerts />;

      default:
        return <AdminCards onNavigate={setCurrentPage} />;
    }
  };

  const getHeaderTitle = () => {
    switch (currentPage) {
      case "dashboard":
        return "Admin Dashboard";
      case "users":
        return "Users";
      case "admins":
        return "Admins";
      case "devices":
        return "Devices";
      case "patients":
        return "Patients";
      case "bluetooth-wifi-connect":
        return "Bluetooth / WiFi Connect";
      case "watch-alerts":
        return "Watch Alerts";
      case "fall-alerts":   // ✅ Added
        return "Fall Alerts";
      default:
        return "Page Not Found";
    }
  };

  return (
    <div className="main-content">
      <Sidebar onOptionClick={setCurrentPage} />
      <Navbar />

      <header className="admin-header">
        <h1>{getHeaderTitle()}</h1>
      </header>

      {renderBodyContent()}

      <AdminFooter />
    </div>
  );
};

export default AdminPage;